import React from 'react';

import { ILookupModel } from 'services';

import './SearchFilteredTags.scss';

/**
 * ISearchFilteredTags
 *
 * @description Component properties for SearchFilteredTags
 * @property {Array<ILookupModel>}  tags            List of filtered tags
 * @property {boolean}              showDescription Indicates whether to display the 'Showing result for...' description
 * @property {(id: string) => void} onRemove        OnRemove callback handler
 */
interface ISearchFilteredTags {
  tags: Array<ILookupModel & { fieldName: string; }>;
  showDescription?: boolean;
  onRemove: (id: string, fieldName: string) => void;
}

/**
 * SearchFilteredTags
 *
 * @description Common component to display list of filters as removable tags which can then update the filters
 */
const SearchFilteredTags: React.FC<ISearchFilteredTags> = ({ tags, onRemove, showDescription = true }) => {
  return (
    <div className='filtered-search-tags'>
      {
        showDescription &&
        tags.length > 0 &&
          <p className='filtered-search-tags__description'>
            Showing results for...
          </p>
      }
      {
        tags.length > 0 &&
        <div className='filtered-search-tags__results-tags'>
          {
            tags.map(tag => (
              <div className='filtered-search-tags__result-tag' key={tag.value}>
                {tag.label}
                <button
                  type='button'
                  className='filtered-search-tags__remove-button'
                  onClick={() => onRemove(tag.value, tag.fieldName)}
                />
              </div>
            ))
          }
        </div>
      }
    </div>
  );
};

export default SearchFilteredTags;